/**
 *
 * CustomBreakpoint
 *
 */

import React from 'react';
import lvTheme from 'utils/theme';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
const customTheme = {
  ...lvTheme,
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 1024,
      lg: 1280,
      xl: 1920,
    },
  },
};
const muiTheme = createMuiTheme(customTheme);

/* eslint-disable */
const withCustomBreakpoint = WrappedComponent =>
  class extends React.Component {
    render() {
      return  <MuiThemeProvider theme={muiTheme}>
         <WrappedComponent {...this.props} />
        </MuiThemeProvider>;
    }
  };

export default withCustomBreakpoint;
